export const CHANNEL_APP_KEY_CICP = 'channel_app_key_cicp'
export const ZHIYINLUO_APP = 'xes_zhiyinlou_app'
export const WANGXIAO_APP = 'xes_wangxiao_app'
